declare var STATIC_BASE_URL:string;

import '../styles/about.scss';

import { h, Component } from 'preact';
import Illustration from './illustration';

export default class About extends Component<any, any> {

    private ppl: any;
    private imgBasePath: string;

    constructor() {
        super();

        this.imgBasePath = STATIC_BASE_URL + 'images/public/userIcos/';

        this.ppl = [
          {
            name: 'Maurizio Ranaboldo',
            img: 'maurizio-ranaboldo.jpg',
            title: 'CTO'
          },
          {
            name: 'John Lapolla',
            img: 'jhon.jpg',
            title: 'Marketing and Communications Director'
          },
          {
            name: 'Raffaele Tiberio',
            img: 'raffaele-tiberio.jpg',
            title: 'CDO',
            chat: 'https://www.querlo.com/chat/raffi'
          },
          {
            name: 'Cara Martin',
            img: 'cara-martin.jpg',
            title: 'Head of Content'
          },
          {
            name: 'Francesco Carignani',
            img: 'francesco-carignani.jpg',
            title: 'Lead System Administrator'
          },
          {
            name: 'Lorenzo Meriggi',
            img: 'lorenzo-meriggi.jpg',
            title: 'Head of UX/UI',
            chat: 'https://www.querlo.com/chat/lry'
          },
          {
            name: 'Jing Jin',
            img: 'jin.jpg',
            title: 'Project Manager',
            chat: 'https://www.querlo.com/chat/jj'
          },{
            name: 'Isaac Mensah',
            img: 'isaac-mensah.jpg',
            title: 'Director of Finance'
          },{
            name: 'Nupur Malpani',
            img: 'nupur.jpg',
            title: 'Finance Consultant'
          },
          {
            name: 'Virali Shah',
            img: 'virali.jpg',
            title: 'NLU Specialist'
          },
          {
            name: 'Ellyn Hsu',
            img: 'ellyn-hsu.jpg',
            title: 'After Sales Manager'
          },
          {
            name: 'Ivana Thomson',
            img: 'ivana-thomson.jpg',
            title: 'Marketing Associate',
            chat: 'https://www.querlo.com/chat/ivana'
          },{
            name: 'Chris Travis',
            img: 'chris-travis.jpg',
            title: 'General Counsel'
          },
          {
            name: 'Zoran Sevarac',
            img: 'zoran-sevarac.jpg',
            title: 'AI Expert'
          },{
            name: 'Fernando Farroni',
            img: 'fernando-farroni.jpg',
            title: 'Consultant'
          },{
            name: 'Vito Pascazio',
            img: 'vito-pascazio.jpg',
            title: 'Consultant'
          },
          {
            name: 'Mohammed Yaser',
            img: 'mohammed-yaser.jpg',
            title: 'Arabic NLU specialist',
            chat: 'https://www.querlo.com/chat/11143'
          }
        ];
    }

    public render (props, state): any {

        const team = this.ppl.map( p => <li>
          <figure>
            <div>
              <img src={ this.imgBasePath + p.img } alt={ p.name } />
            </div>
            <figcaption>
              <h3>{ p. name }</h3>
              <h4>{ p.title }</h4>
              { p.chat ? <a href={ p.chat } target="_blank"><i class="far fa-comment"></i> Know more about me</a> : '' }
            </figcaption>
          </figure>
        </li>);

        return <div id="about">
            <div class="mainWrp">
              <section>
                <h1>About us</h1>
                <h2 class="content">
                  We are a team of technologists, data scientists and business consultants with a mission to unleash the power of AI to improve business performance and build a new era of business efficiency.
                </h2>
            </section>
          </div>
          <section class="story full grey">
            <h2>Our Story</h2>
            <ul>
              <li>
                <h3>1995</h3>
                <p>
                  Established.
                </p>
              </li>
              <li>
                <h3>2004</h3>
                <p>
                  Initiated its first digital transformation.
                </p>
              </li>
              <li>
                <h3>2005</h3>
                <p>
                  Launched a leading video hosting and ad-server technology.
                </p>
              </li>
              <li>
                <h3>2011</h3>
                <p>
                  Empowered 55,000 young women in digital literacy.
                </p>
              </li>
              <li>
                <h3>2013</h3>
                <p>
                  Introduced blockchain and BTC services.
                </p>
              </li>
              <li>
                <h3>2014</h3>
                <p>
                  Captured more than 1 million users and created the first gamified avatar social media platform.
                </p>
              </li>
              <li>
                <h3>2015</h3>
                <p>
                  Launched its Artificial Intelligence platform.
                </p>
              </li>
              <li>
                <h3>2019</h3>
                <p>
                  Over 6000 AI solutions created working with more than 35 worldwide brands.
                </p>
              </li>
            </ul>
          </section>
          <section class="full">
            <h2>Our Philosophy</h2>
            <p>
              If we want technology to be responsible for tasks that belong to humans, then technology should have the smartest IQ. That’s why our motto has always been to “Create technology with a heart.” 
            </p>
          </section>
          <div class="mainWrp">
            <section class="founder">
              <h2>Our Founder</h2>
              <figure>
                <div>
                  <div class="portrait">
                    <img src={ this.imgBasePath + 'rulli.jpg' } alt="Francesco Rulli" />
                  </div>
                  <p><a href="https://www.linkedin.com/in/francescorulli/" target="_blank">LinkedIn</a> | <a href="https://en.wikipedia.org/wiki/Francesco_Rulli" target="_blank">Wikipedia</a></p>
                </div>
                <figcaption>
                  <h3>Francesco Rulli</h3>
                  <h4>Founder & CEO</h4>
                  <p>
                  Francesco Rulli has leveraged a life-long interest in entrepreneurship, media and technology. Previous enterprises include the Film Annex, an online distribution company launched in 2004. Film Annex promoted independent and foreign language films with revenues generated through a custom-designed ad-server and player. <br />
                  Other business ventures soon followed. <a href="https://www.bitlanders.com" target="_blank">BitLanders</a>, a social media platform boasting 1 million users, has an extended footprint across the Middle East and Asia-Pacific Rim. Now an industry leader in gamification, BitLanders has several pending patents, including a content ranking system, Buzz Score, and BitMiles, a rewarding system inspired by the Medici family’s double ledger accounting system.<br />
                  Rulli’s philanthropic efforts extend to Afghanistan, where he sponsored the construction of thirteen classrooms, providing students with the tools and opportunities for digital citizenships. <br />
                  Rulli has since cast his eye on Dubai, a flourishing city committed to becoming a leader in digital technology and Artificial Intelligence.<br />
                  In 2015, Rulli launched a series of chatbots on BitLanders, providing a robust environment and laboratory for conversational AI. Applying proprietary software, Rulli and his team developed and refined tools to improve interactions between customers and their favourite brands. <br />
                  The success of Bitlanders chatbots was such, that Rulli soon realized the impact they could have for individuals and organizations, providing an innovative and secure way to interact with their customers and stakeholders.<br />
                  Today Querlo is a reality, and the main focus of Rulli’s work, having reached more than 1 million users, 35 brands, and 1,000 conversational solutions.
                  </p>
                  <a href="https://www.querlo.com/chat/francescorulli" target="_blank"><i class="far fa-comment"></i> Know more about me</a>

                </figcaption>
              </figure>
            </section>
            {/*<section class="team">
              <h2>The Core Team</h2>
              <ul>

                { team }

              </ul>
            </section>*/}
          </div>
        </div>;

    }
}



// WEBPACK FOOTER //
// ./ts/About.tsx